import clsx from 'clsx'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { NoContactsFound } from 'components/templates/NoSearchResult'
import { CONSTS } from 'config/objectConst'
import { campaignHooks, CampaignsUI } from 'features/campaigns'
import * as Contacts from 'features/contacts'
import { hooks as ODataHooks } from 'shared/odata'
import { typo } from 'shared/styles'
import { Button, ContactsTable, StackIcon } from 'shared/ui'

import css from './CampaignContacts.module.scss'
import { Add, AddToLaunch } from './fallback-cards'
import { useIsLaunch } from './useIsLaunch'

export function ContactsFlow() {
	const { isApplied, params } = ODataHooks.useParseUrl('DraftCampaign')
	const { data, isFetching, isLoading, isSuccess } =
		Contacts.api.useContactPageQuery(params, {
			refetchOnMountOrArgChange: true
		})

	ODataHooks.useCheckPagination({
		data,
		isApplied,
		isReady: isSuccess && !isFetching
	})
	// useAutomationEnded(() => {
	// 	refetch()
	// })

	const isLaunch = useIsLaunch()

	if (isLoading) {
		return <FullLoader className={css.loader} />
	}

	if (!isSuccess) {
		return null
	}

	const { documents: contacts, total } = data

	const noData = total === 0

	if (noData && !isApplied) {
		return isLaunch ? <AddToLaunch /> : <Add />
	}

	return (
		<>
			<Header />
			{isFetching && ContactsTable.Spinner}
			{noData ? (
				<NoContactsFound />
			) : (
				<Contacts.ui.CampaignTable
					contacts={contacts}
					filter={params}
					total={total}
				/>
			)}
		</>
	)
}

function Header() {
	const { campaign } = campaignHooks.useCurrent()
	return (
		<div className={css.header}>
			<h1 className={clsx(css.title, typo.subSection)}>
				{campaign?.name ?? ''}
			</h1>

			<CampaignsUI.ActionControlButtons className={css.headerActions} />

			<Button
				className={css.headerActions}
				onClick={Contacts.ui.AddModal.open}
				variant='bordered-dark'
			>
				<StackIcon icon='plus' />
				Add more contacts
			</Button>

			{CONSTS.IS_RESIZABLE_TABLE && <Contacts.ui.ColumnSettingsCampaign />}
		</div>
	)
}
